import axios from './axios'
import * as c from './config'

export const Login = ({ email, password }) =>
  new Promise((resolve, reject) => {
    if (email && password) {
      axios
        .post(c.LOGIN, { email, password })
        .then((response) => {
          resolve(response.data)
        })
        .catch((err) => {
          reject(err)
        })
    }
  })
export const ListUsers = () =>
  new Promise((resolve, reject) => {
    axios
      .get(c.LISTUSERS)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
export const AddTaux = ({ fxRateCustomer }) =>
  new Promise((resolve, reject) => {
    axios
      .post(c.ADDTAUX, { fxRateCustomer })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
export const ListeFxrates = () =>
  new Promise((resolve, reject) => {
    axios
      .get(c.GETFXRATES)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
export const ListeTransfers = () =>
  new Promise((resolve, reject) => {
    axios
      .get(c.GETTRANSFERS)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
export const ListeCommissions = () =>
  new Promise((resolve, reject) => {
    axios
      .get(c.GETCOMMISSIONS)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
export const AddCOMMISSION = ({ value, minAmount, maxAmount }) =>
  new Promise((resolve, reject) => {
    axios
      .post(c.ADDCOMMISSIONS, { value, minAmount, maxAmount })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

export const GetImage = (id) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETIMAGE}/${id}`)
      .then((response) => {
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
export const GetUser = (id) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.LISTUSERS}/${id}`)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

export const ConfirmedClient = ({ id }) =>
  new Promise((resolve, reject) => {
    axios
      .post(`${c.CONFIRMEDCLIENT}/${id}`)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

export const UPDATETRANSFER = ({ transferId, identityCard, file1, file2 }) =>
  new Promise((resolve, reject) => {
    axios
      .put(
        `${c.UPDATETRANSFER}/${transferId}`,
        {
          identityCard,
          file1,
          file2,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
export const ValidTransfer = ({ transferId }) =>
  new Promise((resolve, reject) => {
    axios
      .post(`${c.VALIDTRANSFER}`, { transferId })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

export const GetBalance = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETBALANCE}`)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

export const UpdateBalance = ({ settingId, balance, fxrate }) =>
  new Promise((resolve, reject) => {
    axios
      .post(`${c.UPDATEBALANCE}`, {
        settingId,
        balance,
        fxrate,
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
export const AddAgent = ({ email, password }) =>
  new Promise((resolve, reject) => {
    axios
      .post(`${c.ADDAGENT}`, { email, password, network: 'BT' })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

export const GetOneTransfer = ({ code }) =>
  new Promise((resolve, reject) => {
    axios
      .post(`${c.GETONETRANSFER}`, { code })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

export const GetListBalance = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETLISTBALANCE}`)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

export const GetBalanceTransfer = () =>
  new Promise((resolve, reject) => {
    axios
      .get(`${c.GETBALANCETRANSFER}`)
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

  export const FnSendSms = ({ userIDs }) =>
  new Promise((resolve, reject) => {
    axios
      .post(`${c.SendSms}`, { userIDs })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
  export const FnCancelTranfer = ({ transferId }) =>
  new Promise((resolve, reject) => {
    axios
      .post(`${c.CancelTranfer}`, { transferId:transferId })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
  
  